import { createSlice } from "@reduxjs/toolkit";
import {
  addApiCases,
  addApiCasesTable,
  createDynamicThunk,
} from "../../../../service/requestHandler";

export const cisListData = createDynamicThunk(
  "cisListData",
  "/api/v1/tenableNessusComplianceRest/list/cisBenchMark",
  ["pageNumber", "itemsPerPage"]
);

export const cisListCounts = createDynamicThunk(
  "cisListCounts",
  "/api/v1/tenableNessusComplianceRest/cisBenchMarkListPaginationCount"
);

export const cIStargetDate = createDynamicThunk(
  "cIStargetDate",
  "/report/api/v1/cisBenchMark/getTargetDates"
);

export const cISActionPlanApi = createDynamicThunk(
  "cISActionPlanApi",
  "/report/api/v1/cisBenchMark/CisBenchmarkActionPlanCounts"
);

export const cISUnplannedApi = createDynamicThunk(
  "cISUnplannedApi",
  "/report/api/v1/cisBenchMark/unplanned/count"
);

export const cISApplicationApi = createDynamicThunk(
  "cISApplicationApi",
  "/report/api/v1/cisBenchMark/getComplianceByApplicationForCisBenchmark"
);

export const cISCriticalityApi = createDynamicThunk(
  "cISCriticalityApi",
  "/report/api/v1/cisBenchMark/getCriticalityStatusCount"
);

export const cISServerityApi = createDynamicThunk(
  "cISServerityApi",
  "/report/api/v1/cisBenchMark/getSeverityStatusCount"
);

export const cISTargetTrendApi = createDynamicThunk(
  "cISTargetTrendApi",
  "/report/api/v1/cisBenchMark/cis/getSixMonthTargetDate"
);

export const currentCISTableApi = createDynamicThunk(
  "currentCISTableApi",
  "/report/api/v1/cisBenchMark/openVulnerabilityList",
  ["pageNumber", "itemsPerPage"]
);


export const currentCISTableCountApi = createDynamicThunk(
  "currentCISTableCountApi",
  "/api/v1/tenableNessusComplianceRest/cisBenchMarkListPaginationCountForCurrentFindings"
);

export const fixedCISTableApi = createDynamicThunk(
  "fixedCISTableApi",
  "",
  ["pageNumber", "itemsPerPage"]
);

export const fixedCISTableCountApi = createDynamicThunk(
  "fixedCISTableCountApi",
  "/api/v1/tenableNessusComplianceRest/cisBenchMarkListPaginationCountForFixedFindings"
);

export const exportCISCurrentCSV = createDynamicThunk(
  "exportCISCurrentCSV",
  "/report/api/v1/cisBenchMark/exportCisBenchmarkOpenVulnerabilityListAsCSV",
  [],
  "POST",
  {
    responseType: "blob",
    acceptHeader: "application/octet-stream",
  }
);

export const exportCISClosedCSV = createDynamicThunk(
  "exportCISClosedCSV",
  "/report/api/v1/cisBenchMark/exportCisBenchmarkClosedVulnerabilityListAsCSV",
  [],
  "POST",
  {
    responseType: "blob",
    acceptHeader: "application/octet-stream",
  }
);

export const exportCISExcludedCSV = createDynamicThunk(
  "exportCISExcludedCSV",
  "/report/api/v1/cisBenchMark/exportCisBenchmarkExcludedVulnerabilityListAsCSV",
  [],
  "POST",
  {
    responseType: "blob",
    acceptHeader: "application/octet-stream",
  }
);

export const initialState = {
  cisListDataData: [],
  cisListDataLoading: false,
  cisListCountsData: [],
  cisListCountsLoading: false,
  cIStargetDateData: [],
  cIStargetDateLoading: false,
  cISActionPlanApiData: [],
  cISActionPlanApiLoading: false,
  cISUnplannedApiData: [],
  cISUnplannedApiLoading: false,
  cISApplicationApiData: [],
  cISApplicationApiLoading: false,
  cISCriticalityApiData: [],
  cISCriticalityApiLoading: false,
  cISServerityApiData: [],
  cISServerityApiLoading: false,
  cISTargetTrendApiData: [],
  cISTargetTrendApiLoading: false,
  currentCISTableApiData: [],
  currentCISTableApiLoading: false,
  fixedCISTableApiData: [],
  fixedCISTableApiLoading: false,
  fixedCISTableCountApiData: [],
  fixedCISTableCountApiLoading: false,
  exportCISCurrentCSVData: null,
  exportCISCurrentCSVLoading: false,
  exportCISClosedCSVData: null,
  exportCISClosedCSVLoading: false,
  exportCISExcludedCSVData: null,
  exportCISExcludedCSVLoading: false,
};

export const CISBenchmarkSlice = createSlice({
  name: "CISBenchmarkSlice",
  initialState,
  reducers: {
    resetCISBenchmarkSlice: () => initialState,
    resetCISBenchmarkData: () => initialState,
  },
  extraReducers: (builder) => {
    addApiCases(builder, cisListData, "cisListDataData");
    addApiCases(builder, cisListCounts, "cisListCountsData");
    addApiCases(builder, cIStargetDate, "cIStargetDateData");
    addApiCases(builder, cISActionPlanApi, "cISActionPlanApiData");
    addApiCases(builder, cISUnplannedApi, "cISUnplannedApiData");
    addApiCases(builder, cISApplicationApi, "cISApplicationApiData");
    addApiCases(builder, cISCriticalityApi, "cISCriticalityApiData");
    addApiCases(builder, cISServerityApi, "cISServerityApiData");
    addApiCases(builder, cISTargetTrendApi, "cISTargetTrendApiData");
    addApiCases(builder, currentCISTableApi, "currentCISTableApiData");
    addApiCases(builder, fixedCISTableApi, "fixedCISTableApiData");
    addApiCases(builder, exportCISCurrentCSV, "exportCISCurrentCSVData");
    addApiCases(builder, exportCISClosedCSV, "exportCISClosedCSVData");
    addApiCases(builder, exportCISExcludedCSV, "exportCISExcludedCSVData");
  },
});

export const { resetCISBenchmarkSlice, resetCISBenchmarkData } =
  CISBenchmarkSlice.actions;
export default CISBenchmarkSlice.reducer;
